<template>
  <div class="v-loader">
    <div class="v-loader__loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VLoader',
  };
</script>

<style lang="scss">
  $size: 15px;

  .v-loader {
    display: inline-block;

    &__loader {
      position: relative;
      height: $size;
    }
    &__loader div {
      position: absolute;
      width: $size;
      height: $size;
      border-radius: 50%;
      background: #e2000e;
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    &__loader div:nth-child(1) {
      left: 6px;
      animation: lds-ellipsis1 0.6s infinite;
    }
    &__loader div:nth-child(2) {
      left: 6px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    &__loader div:nth-child(3) {
      left: 26px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    &__loader div:nth-child(4) {
      left: 45px;
      animation: lds-ellipsis3 0.6s infinite;
    }

    @keyframes lds-ellipsis1 {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }
    @keyframes lds-ellipsis3 {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(0);
      }
    }
    @keyframes lds-ellipsis2 {
      0% {
        transform: translate(0, 0);
      }
      100% {
        transform: translate(19px, 0);
      }
    }
  }
</style>
